import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import Button from '@material-ui/core/Button';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { toast } from 'react-toastify';
import { get, isEmpty, isNumber } from 'lodash';
import { Spinner } from '~/components';
import { Input, Autocomplete, InputText } from '~/components/Form';
import { SelectComplete } from '~/componentslocal';
import api from '~/services/api';
import { Container } from './styles';

import { t, number } from '~/helpers';

import {
  storeOperacaoPreRecebimento,
  updateOperacaoPreRecebimento,
} from '~/store/modules/operacaoprerecebimento/actions';
import posto from '~/store/modules/posto/reducer';

export default function CreateOrUpdate({ reference, data, create, toggleConfirmButton }) {
  const dispatch = useDispatch();
  const [selected, setSelected] = React.useState([]);
  const { usuarioacesso } = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [pocoRecebeFracioando, setPocoRecebeFracioando] = React.useState(false);
  //Variavei para EDITAR
  const [codEditPrreCodigo, setCodEditPrreCodigo] = React.useState('');
  const [codEditPrreStatus, setCodEditPrreStatus] = React.useState(0);
  //Variaveis do DADOS DA UNIDADE RECEPTORA DO PRODUTO (DURP)
  const [notaFiscalDURP, setNotaFiscalDURP] = React.useState('');
  const [valueOrgaoDURP, setValueOrgaoDURP] = React.useState(0);
  const [inputValueOrgaoDURP, setInputValueOrgaoDURP] = React.useState('');
  const [dataNfRetornoDURP, setDataNfRetornoDURP] = React.useState({});
  const [atualizaEntradadosDURP, setAtualizaEntradadosDURP] = React.useState(
    false
  );
  const [clearOrgao, setClearOrgao] = useState(false)
  //Variaveis do DADOS DA NOTA FISCAL (DNF)
  const [pedidoDNF, setPedidoDNF] = React.useState('');
  const [notaFiscalDNF, setNotaFiscalDNF] = React.useState('');
  const [emissaoNFDNF, setEmissaoNFDNF] = React.useState('');
  const [volumeDNF, setVolumeDNF] = React.useState('');
  const [precoUnitDNF, setPrecoUnitDNF] = React.useState('');
  const [valorTotalDNF, setValorTotalDNF] = React.useState('');
  const [combustivelDNF, setCombustivelDNF] = React.useState('');
  const [distribuidoraDNF, setDistribuidoraDNF] = React.useState('');
  const [transportadoraDNF, setTransportadoraDNF] = React.useState('');
  const [placaCTDNF, setPlacaCTDNF] = React.useState('');
  const [motoristaDNF, setMotoristaDNF] = React.useState('');
  const [orgaoDNF, setOrgaoDNF] = React.useState('');
  const [codigoCombustivelDNF, setCodigoCombustivelDNF] = React.useState('');
  //Variaveis d GRIDE NOTA FISCAL (GNF)
  const [rowsGNF, setRowsGNF] = React.useState([]);
  //Variaveis do RESUMO DO Recebimento Provisório RPR
  const [volumeTotalRPF, setVolumeTotalRPF] = React.useState(0);
  const [atualizaRPF, setAtualizaRPF] = React.useState(false);

  const [produtoRPF, setProdutoRPF] = React.useState('');

  const [exibircontratogta, setExibircontratogta] = React.useState(0);
  const [contratogta, setContratogta] = React.useState('');
  const [contratogtaTela, setContratogtaTela] = React.useState('');
  const [pococodigo, setPococodigo] = React.useState('');
  const [usua_login_recebedor_responsavel, setUsua_login_recebedor_responsavel] = React.useState('');
  const [usua_nome, setUsua_nome] = React.useState('');
  const [usua_cpf, setUsua_cpf] = React.useState('');
  const [prre_num_ano_empenho, setPrre_num_ano_empenho] = React.useState('');

  //Variaveis para Editar
  const [preRecebimentoVO, setPreRecebimentoVO] = React.useState([]);


  function createData(nf, produto, codorgao, descorgao, volume) {
    return { nf, produto, codorgao, descorgao, volume };
  }

  function limpaDadosPesquisaNotaFiscal() {
    reference.current.setFieldValue('notaFiscalDURP', '')
    setNotaFiscalDURP('')
    setClearOrgao(true)
    setDataNfRetornoDURP({});
    setAtualizaEntradadosDURP(false);

  }

  //Funcoes para DADOS DA UNIDADE RECEPTORA DO PRODUTO (DURP)
  //Busca Nota Fiscal
  async function buscaNotaFiscalDURPHandler() {
    limpaDadosNotaFiscal();
    setAtualizaEntradadosDURP(false);
    if (!notaFiscalDURP) {
      toast.error('NF: esta informação é obrigatória!');
      return;
    }
    if (Number(notaFiscalDURP) > 2147483647) {
      toast.error('Número de NF inválido !');
      return;
    }
    if (!valueOrgaoDURP) {
      toast.error('Órgão: esta informação é obrigatória!');
      return;
    }
    let codPrreCodigo = '0';
    if (codEditPrreCodigo) {
      codPrreCodigo = String(codEditPrreCodigo);
    }
    try {
      setIsLoading(true);
      const numero_nf = notaFiscalDURP;
      const poco_codigo = get(usuarioacesso, 'poco_codigo', '');
      const orga_codigo = String(valueOrgaoDURP);
      const codigo_frentista = get(usuarioacesso, 'usua_login', '');
      const response = await api.get(
        `/prerecebimento/${codPrreCodigo}/${numero_nf}/${poco_codigo}/${orga_codigo}/${codigo_frentista}`
      );
      await setIsLoading(false);
      const dataNfRetorno = get(response, 'data', '');
      if (String(dataNfRetorno) === '') {
        toast.error('Não foi possível fazer a consulta!');
        return;
      }
      setDataNfRetornoDURP(response.data);
    } catch (err) {
      setDataNfRetornoDURP({});
      setIsLoading(false);
      toast.error(` ${err} `);
    }
  }

  //Verificar se a Nota fiscal já está incluida na lista!
  function verificaSeNFJaEstaNaLista(nf) {
    let listaNf = rowsGNF;
    for (let i = 0; i < listaNf.length; i++) {
      if (listaNf[i].nf === nf) {
        return 1;
      }
    }
    return 0;
  }

  //Verificar se a Nota fiscal já está incluida na lista!
  function verificaSeProdutoNaLista(produto) {
    let listaNf = rowsGNF;
    for (let i = 0; i < listaNf.length; i++) {
      if (listaNf[i].produto !== produto) {
        return 1;
      }
    }
    return 0;
  }

  //********************************** */
  //Effect para setDataNfRetornoDURP.
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const dataNfRetorno = get(dataNfRetornoDURP, 'desc_nf', '');
      if (dataNfRetorno === '') {
        return;
      }
      //Regra 01
      async function localVerificaSeNFJaEstaNaLista() {
        const estaNalista = await verificaSeNFJaEstaNaLista(
          dataNfRetornoDURP.desc_nf
        );
        if (estaNalista) {
          setAtualizaEntradadosDURP(false);
          limpaDadosNotaFiscal();
          toast.error('Nota fiscal já está incluida na lista!');
          return 1;
        }
        return 0;
      }
      if (!localVerificaSeNFJaEstaNaLista()) {
        return;
      }

      //Regra 02
      async function localVerificaSeProdutoNaLista() {
        const estaNalista = await verificaSeProdutoNaLista(
          dataNfRetornoDURP.prod_display
        );
        if (estaNalista) {
          limpaDadosNotaFiscal();
          setAtualizaEntradadosDURP(false);
          toast.error(
            'O produto da Nota fiscal divergente do que está incluído no recebimento provisório!'
          );
          return 1;
        }
        return 0;
      }
      if (!localVerificaSeProdutoNaLista()) {
        return;
      }
      setAtualizaEntradadosDURP(true);
    }
    return function cleanup() {
      mounted = false;
    };
  }, [dataNfRetornoDURP]);

  //********************************** */
  //Atualiza DADOS DA NOTA FISCAL
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!atualizaEntradadosDURP) {
        return;
      }
      setPedidoDNF(dataNfRetornoDURP.desc_num_pedido);
      setNotaFiscalDNF(dataNfRetornoDURP.desc_nf);
      setEmissaoNFDNF(dataNfRetornoDURP.desc_dt_emissao_nf);
      setVolumeDNF(dataNfRetornoDURP.desc_volume_nf);
      setPrecoUnitDNF(dataNfRetornoDURP.desc_preco_unitario);
      setValorTotalDNF(dataNfRetornoDURP.desc_valor_total);
      setCombustivelDNF(dataNfRetornoDURP.prod_display);
      setDistribuidoraDNF(dataNfRetornoDURP.desc_distribuidora);
      setTransportadoraDNF(dataNfRetornoDURP.desc_transportadora);
      setPlacaCTDNF(dataNfRetornoDURP.desc_placa_ct);
      setMotoristaDNF(dataNfRetornoDURP.desc_motorista);
      setOrgaoDNF(dataNfRetornoDURP.nfre_destinat_nome);
      setCodigoCombustivelDNF(dataNfRetornoDURP.prod_codigo);
    }
    return function cleanup() {
      mounted = false;
    };
  }, [atualizaEntradadosDURP]);

  function limpaDadosNotaFiscal() {
    setPedidoDNF('');
    setNotaFiscalDNF('');
    setEmissaoNFDNF('');
    setVolumeDNF('');
    setPrecoUnitDNF('');
    setValorTotalDNF('');
    setCombustivelDNF('');
    setDistribuidoraDNF('');
    setTransportadoraDNF('');
    setPlacaCTDNF('');
    setMotoristaDNF('');
    setOrgaoDNF('');
  }

  function adicionarNF() {
    let newRowsGNF = [];
    const obj = createData(
      notaFiscalDNF,
      combustivelDNF,
      valueOrgaoDURP,
      inputValueOrgaoDURP,
      volumeDNF
    );
    newRowsGNF = newRowsGNF.concat(rowsGNF, obj);
    setRowsGNF(newRowsGNF);
    limpaDadosNotaFiscal();
    limpaDadosPesquisaNotaFiscal();
    setAtualizaRPF(true);

    setProdutoRPF(combustivelDNF);
  }

  function atualizaVolumeTotalRPF() {
    let listaNf = rowsGNF;
    let total = 0.0;
    for (let i = 0; i < listaNf.length; i++) {
      const volume = Number(listaNf[i].volume);
      total = total + volume;
    }
    setVolumeTotalRPF(total);
    if (total === 0.0) {
      setProdutoRPF('');
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!atualizaRPF) {
        return;
      }
      setAtualizaRPF(false);
      atualizaVolumeTotalRPF();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [atualizaRPF]);


  //********************** */
  //********************** */
  //***TESTE DIALOG  INICIO*/
  // const [open, setOpen] = React.useState(false);
  // const [value, setValue] = React.useState('CLICK-OK');
  // const handleClickListItem = () => {
  //   setOpen(true);
  // };
  // const handleClose = (newValue) => {
  //   console.log(newValue);
  //   setOpen(false);
  //   if (newValue) {
  //     setValue(newValue);
  //   }
  // };

  // function ConfirmationDialogRaw(props) {
  //   const { onClose, value: valueProp, open, ...other } = props;
  //   const [value, setValue] = React.useState(valueProp);
  //   const radioGroupRef = React.useRef(null);

  //   React.useEffect(() => {
  //     if (!open) {
  //       setValue(valueProp);
  //     }
  //   }, [valueProp, open]);

  //   const handleEntering = () => {
  //     if (radioGroupRef.current != null) {
  //       radioGroupRef.current.focus();
  //     }
  //   };

  //   const handleCancel = () => {
  //     onClose();
  //   };

  //   const handleOk = () => {
  //     onClose(value);
  //   };

  //   const handleChange = (event) => {
  //     setValue(event.target.value);
  //   };

  //   const isSelected = (name) => selected.indexOf(name) !== -1;

  //   return (
  //     <div>
  //       <Dialog
  //         disableBackdropClick
  //         disableEscapeKeyDown
  //         maxWidth="xs"
  //         onEntering={handleEntering}
  //         aria-labelledby="confirmation-dialog-title"
  //         open={open}
  //         {...other}
  //       >
  //         <DialogTitle id="confirmation-dialog-title">Confirmar</DialogTitle>
  //         <DialogContent dividers>
  //           <span>O KM anterior é maior que o KM atual. Deseja Salvar?</span>
  //         </DialogContent>
  //         <DialogActions>
  //           <Button autoFocus onClick={handleCancel} color="primary">
  //             Cancel
  //           </Button>
  //           <Button onClick={handleOk} color="primary">
  //             Ok
  //           </Button>
  //         </DialogActions>
  //       </Dialog>
  //     </div>
  //   );
  // }
  //***TESTE DIALOG  FIM*/
  //********************** */
  //********************** */

  const { loading, find, params } = useSelector(
    (state) => state.operacaoprerecebimento
  );

  const initials = create ? data : { ...find, ...data };

  //Só pode receber modulo 5000 CARLOS
  function validaRegraDoDivisor5000() {
    const regraDoDivisor5000 = volumeTotalRPF % 5000.0;

    if (regraDoDivisor5000 === 0) {
      return true;
    } else {
      return false;
    }
  }


  /*** */
  async function handleSubmit(param) {
    try {

      // console.log('param = ', param);

      const schema = Yup.object().shape({
        usua_login: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio')),
        usua_login_responsavel: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30)),
      });

      await schema.validate(param, {
        abortEarly: false,
      });


      if (rowsGNF.length == 0) {
        toast.error('Sem registros a serem salvos!');
        return;
      }

      if (volumeTotalRPF === 0) {
        toast.error('Volume não permitido para cadastro!');
        return;
      }

      if (!validaRegraDoDivisor5000()) {
        toast.error('Volume não permitido para cadastro!');
        return;
      }

      const poco_codigo = get(usuarioacesso, 'poco_codigo', '');
      const codigo_frentista = get(usuarioacesso, 'usua_login', '');

      const objSend = {

        cosi_contratogta: contratogta,
        prre_num_ano_empenho: prre_num_ano_empenho,
        usua_login_recebedor_responsavel: usua_login_recebedor_responsavel,

        poco_codigo: poco_codigo,
        prre_codigo: codEditPrreCodigo,
        prod_codigo: codigoCombustivelDNF,
        prre_login_cadastro: codigo_frentista,
        listaNotasFiscais: rowsGNF,
      };

      // console.log('objSend = ', JSON.stringify(objSend));


      if (create) {
        await dispatch(storeOperacaoPreRecebimento(objSend, params));
      } else {
        await dispatch(updateOperacaoPreRecebimento(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
    // } catch (err) {
    //   const validationErrors = {};
    // }
  }

  useEffect(() => {
    if (rowsGNF.length <= 0) {
      toggleConfirmButton(false)
    } else {
      toggleConfirmButton(true)
    }
  }, [rowsGNF])


  //********************************** */
  //Verificar modo de constulta pelo posto.
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      // console.log('usuarioacesso = ', usuarioacesso);

      const poco_recebimento_fracionado = get(
        usuarioacesso,
        'poco_recebimento_fracionado',
        ''
      );

      const poco_codigo = get(
        usuarioacesso,
        'poco_codigo',
        ''
      );

      setPococodigo(poco_codigo);

      if (String(poco_recebimento_fracionado) !== '') {
        if (String(poco_recebimento_fracionado) === 'S') {
          setPocoRecebeFracioando(true);
        } else {
          setPocoRecebeFracioando(false);
        }
      } else {
        setPocoRecebeFracioando(false);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [usuarioacesso]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (create) {
        setPreRecebimentoVO([]);
      } else {
        const {
          prre_codigo,
          prre_status,
          poco_codigo,
          prod_codigo,
          prod_codigo_display,
          notasFiscais,
        } = find;

        const obj = {
          prre_codigo,
          prre_status,
          poco_codigo,
          prod_codigo_display,
          prod_codigo,
          notasFiscais,
        };
        setPreRecebimentoVO(obj);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [find]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      modoEditarDesserializar();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [preRecebimentoVO]);

  //DAGNO EDITAR!!
  function modoEditarDesserializar() {
    let listaNf = preRecebimentoVO.notasFiscais;
    let newRowsGNF = [];
    if (listaNf) {
      setCodEditPrreCodigo(String(preRecebimentoVO.prre_codigo));
      setCodEditPrreStatus(preRecebimentoVO.prre_status);
      setCodigoCombustivelDNF(preRecebimentoVO.prod_codigo);

      setProdutoRPF(preRecebimentoVO.prod_codigo_display);

      for (let i = 0; i < listaNf.length; i++) {
        const nf = listaNf[i].prri_nf;
        const produto = preRecebimentoVO.prod_codigo_display;
        const codorgao = listaNf[i].orga_codigo;
        const descorgao = listaNf[i].orga_nome;
        const volume = listaNf[i].prri_volume_nf;
        const obj = createData(nf, produto, codorgao, descorgao, volume);
        newRowsGNF = newRowsGNF.concat(rowsGNF, obj);
        setRowsGNF(newRowsGNF);
      }
      setAtualizaRPF(true);
    }
  }

  //Remover item da gride de nota fiscais
  function removerNFHandler() {
    let listaIncluidos = selected;
    let listaNf = rowsGNF;
    let novaListaNf = [];
    let retir = false;
    for (let i = 0; i < listaNf.length; i++) {
      for (let x = 0; x < listaIncluidos.length; x++) {
        if (listaNf[i].nf === listaIncluidos[x]) {
          listaIncluidos.splice(x, 1);
          retir = true;
          break;
        }
      }
      if (!retir) {
        novaListaNf.push(listaNf[i]);
      }
      retir = false;
    }
    setRowsGNF(novaListaNf);
    setSelected([]);
    setAtualizaRPF(true);
  }

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  async function getConfigSistema() {
    try {
      setIsLoading(true);
      const response = await api.get(`/configsistema`);
      const statusRetorno = get(
        response,
        'data.cosi_exibircontratogta',
        'data.cosi_contratogta',
        ''
      );
      await setIsLoading(false);
      if (String(statusRetorno) === '') {
        toast.error('Não foi possível fazer a consulta!');
        return;
      }
      if (response && !isEmpty(response.data)) {
        if (String(response.data.cosi_exibircontratogta) === '1') {
          setExibircontratogta(1);
        } else {
          setExibircontratogta(0);
        }

        // console.log('response.data.cosi_contratogta = ', response.data.cosi_contratogta);

        setContratogtaTela(`Contrato nº ${response.data.cosi_contratogta}`);
        setContratogta(response.data.cosi_contratogta);

      }
    } catch (err) {
      setIsLoading(false);
      setExibircontratogta(0);
      toast.error(` ${err} `);
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConfigSistema();
    }
    return function cleanup() {
      mounted = false;
    };
  }, []);

  return (
    <Container>
      {isLoading ? (
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div>
      ) : (
        ''
      )}

      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : !pocoRecebeFracioando ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <p>O POSTO não é habilitado para esse processo!'</p>
        </div>
      ) : codEditPrreStatus > 0 ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <p>Registro não pode ser alterado!'</p>
        </div>
      ) : (
        <>
          <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
            <div className="Container__grupos">

              <div style={{ height: '3rem', width: '50rem' }}>
                <p>{contratogtaTela}</p>
              </div>

              <Autocomplete
                name="usua_login"
                label="usua_login"
                title="Recebedor Responsável"
                url="usuario/usuariolistagpp"
                unique="usua_login"
                params={{
                  wherefield: ['poco_codigo', 'USUA_STATUS'],
                  valuewherefield: [pococodigo, '1'],
                  typewherefield: ['EQUALS', 'EQUALS'],
                  fieldlist: 'usua_login, usua_nome, usua_cpf',
                }}
                getValue={(value) => {
                  if (value.usua_login !== null) {
                    setUsua_login_recebedor_responsavel(value.usua_login);
                  } else {
                    setUsua_login_recebedor_responsavel('')
                  }

                  if (value.usua_nome !== null) {
                    setUsua_nome(value.usua_nome);
                  } else {
                    setUsua_nome('')
                  }

                  if (value.usua_cpf !== null) {
                    setUsua_cpf(value.usua_cpf);
                  } else {
                    setUsua_cpf('')
                  }
                }}

              />

              {create ?
                <Input
                  name="usua_login_responsavel"
                  label="Nº/Ano do Empenho"
                  disabled={!create}
                  placeholder=""
                  value={prre_num_ano_empenho}
                  getValue={(value) => {
                    setPrre_num_ano_empenho(value);
                  }}
                /> :
                <Input
                  name="usua_login_responsavel"
                  label="Nº/Ano do Empenho"
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled={!create}
                />
              }

              <p>DADOS DA UNIDADE RECEPTORA DO PRODUTO:</p>
              <Button
                color="primary"
                disabled={codEditPrreStatus > 0}
                variant="outlined"
                onClick={buscaNotaFiscalDURPHandler}
              >
                {'Localizar NF'}
              </Button>

              <div className="Container__nf_busca">
                <InputText
                  name="notaFiscalDURP"
                  label="NF"
                  size="small"
                  margin="dense"
                  type="number"
                  value={notaFiscalDURP}
                  getValue={(value) => {
                    setNotaFiscalDURP(value);
                  }}
                  mask="9999999999"
                  placeholder=""
                />

                <SelectComplete
                  name="orga_codigo"
                  label="orga_nome"
                  title="Órgão"
                  id='"orga_codigo'
                  url="orgaos"
                  unique='"orga_codigo'
                  value={valueOrgaoDURP}
                  inputValue={inputValueOrgaoDURP}
                  onChange={(event, newValue) => {
                    setValueOrgaoDURP(newValue);
                  }}
                  onInputChange={(event, newInputValueOrgao) => {
                    setInputValueOrgaoDURP(newInputValueOrgao);
                  }}
                  hiddens={[{ name: 'orga_nome' }]}
                  getValue={(value) => {
                    setClearOrgao(false)
                    if (value.orga_codigo !== null) {
                      setValueOrgaoDURP(value.orga_codigo);
                    } else {
                      setValueOrgaoDURP(0);
                    }
                  }}
                  clearField={clearOrgao}
                  disableClearable={!valueOrgaoDURP}
                />
              </div>

              <p> DADOS DA NOTA FISCAL:</p>
              <Button
                color="primary"
                variant="outlined"
                disabled={atualizaEntradadosDURP === false}
                onClick={adicionarNF}
              >
                {'adicionar NF'}
              </Button>

              <div className="Container__nf_dados">
                <Input
                  name="desc_num_pedido"
                  label="Pedido"
                  disabled
                  value={pedidoDNF}
                />

                <Input
                  name="prod_display"
                  label="Combustível"
                  disabled
                  value={combustivelDNF}
                />

                <Input
                  name="desc_nf"
                  label="Nota Fiscal"
                  disabled
                  value={notaFiscalDNF}
                />

                <Input
                  name="desc_distribuidora"
                  label="Distribuidora"
                  disabled
                  value={distribuidoraDNF}
                />

                <Input
                  name="desc_dt_emissao_nf"
                  label="Emissão NF"
                  disabled
                  value={emissaoNFDNF}
                />

                <Input
                  name="desc_transportadora"
                  label="Transportadora"
                  disabled
                  value={transportadoraDNF}
                />

                <Input
                  name="desc_volume_nf"
                  label="Volume"
                  disabled
                  value={isNumber(volumeDNF) ?
                    number(volumeDNF, 1)
                    : ''}
                />

                <Input
                  name="desc_placa_ct"
                  label="Placa CT"
                  disabled
                  value={placaCTDNF}
                />

                <Input
                  name="desc_preco_unitario"
                  label="Preço Unit."
                  disabled
                  value={precoUnitDNF}
                />

                <Input
                  name="desc_motorista"
                  label="Motorista"
                  disabled
                  value={motoristaDNF}
                />

                <Input
                  name="desc_valor_total"
                  label="Valor Total"
                  disabled
                  value={valorTotalDNF}
                />

                <Input
                  name="nfre_destinat_nome"
                  label="Órgão"
                  disabled
                  value={orgaoDNF}
                />
              </div>

              <p>NOTAS FISCAIS REALACIONADAS</p>
              <Button
                color="primary"
                variant="outlined"
                disabled={selected.length <= 0}
                selected
                onClick={removerNFHandler}
              >
                {'Remover NF'}
              </Button>

              <div className="Container__nf_dados_grade">
                <TableContainer component={Paper}>
                  <Table
                    style={{ minWidth: 380, zIndex: -1 }}
                    size="small"
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align="right"></TableCell>
                        <TableCell align="right">Nota Fiscal</TableCell>
                        <TableCell align="right">Produto</TableCell>
                        <TableCell align="right">Órgão</TableCell>
                        <TableCell align="right">Descrição</TableCell>
                        <TableCell align="right">Volume</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowsGNF.map((row, index) => {
                        const isItemSelected = isSelected(row.nf);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            hover
                            key={row.nf}
                            onClick={(event) => handleClick(event, row.nf)}
                            selected={isItemSelected}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ 'aria-labelledby': labelId }}
                              />
                            </TableCell>
                            <TableCell align="right">{row.nf}</TableCell>
                            <TableCell align="right">{row.produto}</TableCell>
                            <TableCell align="right">{row.codorgao}</TableCell>
                            <TableCell align="right">{row.descorgao}</TableCell>
                            <TableCell align="right">{number(row.volume, 1)}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>

              <p>RESUMO DO RECEBIMENTO PROVISÓRIO</p>

              <div className="Container__nf_dados_resumo">
                <Input
                  name="resumonftotal"
                  label="Volume total NF's:"
                  size="small"
                  margin="dense"
                  value={number(volumeTotalRPF, 1)}
                  disabled
                />
                <Input
                  name="resumonfproduto"
                  label="Produto:"
                  size="small"
                  margin="dense"
                  value={produtoRPF}
                  disabled
                />
                <div style={{ height: '3rem', width: '50rem' }}>
                  <p>{usua_cpf}/{usua_nome} </p>
                </div>
              </div>

            </div>
          </Form>
        </>
      )}

      {/* <div>
        <ConfirmationDialogRaw
          id="ringtone-menu"
          keepMounted
          open={open}
          onClose={handleClose}
          value={value}
        />
      </div> */}
    </Container>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
